import {
  loyaltyApiSlice,
  magentoApiSlice,
  paymentApiSlice,
  platformApiSlice,
  profileApiSlice,
  subscriptionApiSlice,
} from "../slices";

export const apiMiddlewares = [
  loyaltyApiSlice.middleware,
  magentoApiSlice.middleware,
  subscriptionApiSlice.middleware,
  profileApiSlice.middleware,
  paymentApiSlice.middleware,
  platformApiSlice.middleware,
];
